export const SMALL_COLUMN = 60;
export const MEDIUM_COLUMN = 80;
export const LARGE_COLUMN = 100;
export const XL_COLUMN = 175;
export const XXL_COLUMN = 250;
